import Controller from './controller'

export default class extends Controller {
  static values = {
    url: String,
  }

  copy(ev) {
    ev.preventDefault()

    const url = this.urlValue || window.location.href

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url)
      return
    }

    const input = document.createElement('input')
    input.value = url
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }
}
